import React, { useEffect } from 'react';
import './Home.css';
import ILMICON from '../images/ILMICON.png'
import ALKITAB from '../images/ALKITAB.png'
import CarouselActivity from '../components/CarouselActivity';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    FaYoutube,
    FaClinicMedical,
    //   FaTooth, 
    //   FaFlask, 
    FaBookOpen,
    FaTools,
    FaFemale,
    FaUsers,
    FaPhone,
    FaHandsHelping,
    FaUtensils,
    FaShoppingBasket,
    FaTint,
    FaUserGraduate,
    FaUserShield,
    FaVideo,
    FaBook,
    //   FaSearch, 
    FaLanguage,
    FaCalendarAlt,
    FaChild,
    FaChalkboardTeacher,
    FaHands,
    FaCampground,
    FaImages,
    FaSchool,
    FaHandHoldingHeart,
} from 'react-icons/fa';


const Activities = () => {
    const navigate = useNavigate();
    const location = useLocation(); // Proper way to access location in React Router

    // In handleCardClick:
    const handleCardClick = (path) => {
        sessionStorage.setItem('activitiesScrollPosition', window.scrollY);
        window.scrollTo(0, 0); // Scroll to top immediately
        navigate(path);
    };

    // Restore scroll position when component mounts
    useEffect(() => {
        const savedPosition = sessionStorage.getItem('activitiesScrollPosition');
        if (savedPosition) {
            window.scrollTo(0, parseInt(savedPosition));
            sessionStorage.removeItem('activitiesScrollPosition');
        }

        // Alternative using location state
        if (location.state?.restoreScroll) {
            window.scrollTo(0, location.state.scrollPosition || 0);
        }
    }, [location]);


    return (
        <>
            <CarouselActivity />
            <div className="about-us-container">
                {/* Values Section */}
                <section className="home-values-section">
                    <div className="values-header">
                        <h2>Our Activities</h2>
                    </div>
                    <div className="home-values-grid">
                        <div className="home-value-card" onClick={() => handleCardClick('/irc-tv')}>
                            <div className="home-value-icon"><FaYoutube size={50} color="#FF0000" /></div>
                            <h3>IRC TV</h3>
                            <p>IRC TV is a YouTube channel www.YouTube.com/IRCTV with over 4.2 million (42 Lakh) subscribers and 1.1 Billion (110 Crore) views (as on 31-Jan-2025) and counting...</p>
                        </div>
                        <div className="home-value-card" onClick={() => handleCardClick('/irc-charity')}>
                            <div className="home-value-icon"><FaClinicMedical size={50} color="#00AA55" /></div>
                            <h3>IRC CHARITABLE CLINICS (ICC), IRC DENTAL CLINIC (IDC), & IRC PATHOLOGY LABORATORY (IPL)</h3>
                            <p>Alhamdulillaah, Six Charitable Clinics are run by IRC in slum localities of Chhatrapati Sambhajinagar (Aurangabad), that are open to people for all faiths on all weekdays...</p>
                        </div>
                        {/* <div className="home-value-card" onClick={() => handleCardClick('/irc-dental')}>
                            <div className="home-value-icon"><FaTooth size={50} color="#FFFFFF" style={{ backgroundColor: '#00AAEE', borderRadius: '50%', padding: '5px' }} /></div>
                            <h3>IRC DENTAL CLINIC (IDC)</h3>
                            <p>IRC Dental Clinic is a Reason to Smile Again! We are dedicated to providing top-notch dental care to everyone which includes a wide range of services like cleanings, fillings...</p>
                        </div> */}
                        {/* <div className="home-value-card" onClick={() => handleCardClick('/irc-patho')}>
                            <div className="home-value-icon"><FaFlask size={50} color="#AA00FF" /></div>
                            <h3>IRC PATHOLOGY LABORATORY</h3>
                            <p>IRC runs a pathology laboratory (located in the IRC Charitable Clinic Building) where skilled and experienced technicians and pathologists perform laboratory testing for...</p>
                        </div> */}

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-study')}>
                            <div className="home-value-icon"><FaBookOpen size={50} color="#FFAA00" /></div>
                            <h3>IRC STUDY CENTRE (ISC)</h3>
                            <p>Alhamdulillaah, with an aim to encourage education in our society, IRC runs 3 full-fledged Study Centers 2 for boys and 1 exclusively for girls in the city...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-technical')}>
                            <div className="home-value-icon"><FaTools size={50} color="#5555FF" /></div>
                            <h3>IRC TECHNICAL INSTITUTES (ITI)</h3>
                            <p>IRC runs 3 Technical Institutes for poor and needy students for free, where skilled and experienced teachers give various course training like tailoring, fashion designing,...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-women')}>
                            <div className="home-value-icon"><FaFemale size={50} color="#FF00AA" /></div>
                            <h3>IRC WOMEN EMPOWERMENT CENTRE (IWEC)</h3>
                            <p>Women Empowerment is an important issue that needs to be addressed in order to make them Independent where the Education and Freedom scenario is very regressive...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-community')}>
                            <div className="home-value-icon"><FaUsers size={50} color="#00FFAA" /></div>
                            <h3>IRC COMMUNITY CENTRE (IRCCC)</h3>
                            <p>At IRC Community Centre, our mission is to empower our community through accessible healthcare, education, and technical skills development. We are committed to providing...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-call')}>
                            <div className="home-value-icon"><FaPhone size={50} color="#00AAFF" /></div>
                            <h3>IRC HELPLINE</h3>
                            <p>A bench of well-versed and knowledgeable Scholars answers the queries of callers from all over the globe, pertaining to any day-to-day issue in the light of Qur'an and authentic...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-medical')}>
                            <div className="home-value-icon"><FaHandsHelping size={50} color="#FF5500" /></div>
                            <h3>IRC MEDICAL AID, IRC EDUCATIONAL AID, & IRC EMPLOYMENT AID</h3>
                            <p>IRC provides medical, educational and employment aid for the needy and underprivileged people of the society...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-dastar')}>
                            <div className="home-value-icon"><FaUtensils size={50} color="#AA5500" /></div>
                            <h3>IRC DASTARKHWAN (FOOD FOR POOR & NEEDY)</h3>
                            <p>The Prophet Muhammad said: "O people! Spread salam, provide food (to poor & needy), uphold the ties of kinship, and pray during the night when people are sleeping...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-ration')}>
                            <div className="home-value-icon"><FaShoppingBasket size={50} color="#55AA00" /></div>
                            <h3>RATION KITS & FOOD DISTRIBUTION</h3>
                            <p>Ration kits containing food grains. oil, tea, pulses are distributed on a monthly basis to the poor and needy, Alhamdulillaah.</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-water')}>
                            <div className="home-value-icon"><FaTint size={50} color="#0088FF" /></div>
                            <h3>IRC FREE WATER SUPPLY (IFWS)</h3>
                            <p>IRC supplies free clean drinking water and water for storage and use to slums and localities with water scarcity in the city.</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-skill')}>
                            <div className="home-value-icon"><FaUserGraduate size={50} color="#AA00AA" /></div>
                            <h3>SKILL DEVELOPMENT PROGRAMS</h3>
                            <p>In order to encourage underprivileged people of the society to take up industry-relevant skill training that will help them in securing a better livelihood.</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-we')}>
                            <div className="home-value-icon"><FaUserShield size={50} color="#FFAA00" /></div>
                            <h3>WOMEN EMPOWERMENT PROGRAMS</h3>
                            <p>IRC's Women Empowerment programs support the social and economic empowerment of women through providing them skill-building training, self-esteem counselling...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-production')}>
                            <div className="home-value-icon"><FaVideo size={50} color="#AA0000" /></div>
                            <h3>PRODUCTION</h3>
                            <p>IRC has its own production studio where lectures of various speakers of IRC and other guest speakers are recorded, edited and aired on satellite channels, cable TVs...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-refernce')}>
                            <div className="home-value-icon"><FaBook size={50} color="#5500AA" /></div>
                            <h3>REFERENCE BOOKS LIBRARY</h3>
                            <p>IRC hosts its own library containing thousands of books on Religion, History, General Knowledge, Science etc. Books on religion include Islam, Christianity,...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-freebookbank')}>
                            <div className="home-value-icon"><FaBookOpen size={50} color="#FFAA00" /></div>
                            <h3>FREE BOOK BANK </h3>
                            <p>Our Free Book Bank is a community initiative where students can donate their used textbooks and academic books so that other students can take them free of cost. The goal is simple...</p>
                        </div>

                        {/* <div className="home-value-card" onClick={() => handleCardClick('/irc-path')}>
                            <div className="home-value-icon"><FaSearch size={50} color="#00AAAA" /></div>
                            <h3>IRC PATHFINDER</h3>
                            <p>IRC conducts career guidance/counselling programs by the name of IRC PathFinder for youth and students regularly to guide them in choosing right faculties and...</p>
                        </div> */}

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-arabic')}>
                            <div className="home-value-icon">
                                <div style={{
                                    fontFamily: "'Amiri', 'Scheherazade', serif",
                                    fontSize: '52px',
                                    color: '#0055AA',
                                    textAlign: 'center',
                                    lineHeight: '1'
                                }}>
                                    أ ب
                                </div>
                            </div>
                            <h3>IRC ARABIC ACADEMY (IAA)</h3>
                            <p>IRC runs IRC Arabic Academy for boys and girls. The aim of this academy is to inculcate in our new generation authentic Aqeedah, Aamaal, love for the Sunnah &...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-conference')}>
                            <div className="home-value-icon"><FaCalendarAlt size={50} color="#FF0055" /></div>
                            <h3>IRC 10 DAYS CONFERENCE</h3>
                            <p>Since Ramadhaan 2001, IRC has been conducting a 10 Day Annual Educational Conference during the last Ashara (last ten days) of the month of Ramadhaan...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-ladies')}>
                            <div className="home-value-icon"><FaFemale size={50} color="#FF55AA" /></div>
                            <h3>LADIES WING</h3>
                            <p>The Ladies' wing of IRC conducts weekly lectures exclusively for women, by IRC certified male and female speakers, which are attended by hundreds of women...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-children')}>
                            <div className="home-value-icon"><FaChild size={50} color="#55FF00" /></div>
                            <h3>CHILDREN'S WING</h3>
                            <p>Alhamdulillaah, this wing is a boon to the society. It helps our new generation to excel in both religious and worldly education. It creates an enthusiasm amongst the...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-weekly')}>
                            <div className="home-value-icon"><FaChalkboardTeacher size={50} color="#AAFF00" /></div>
                            <h3>WEEKLY LECTURES</h3>
                            <p>IRC conducts weekly lectures for Muslims and Non-Muslims delivered by various speakers from IRC on Socio Religious Issues followed by an open Question &...</p>
                        </div>

                    

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-summer')}>
                            <div className="home-value-icon"><FaCampground size={50} color="#0055FF" /></div>
                            <h3>IRC SUMMER CAMP</h3>
                            <p>Every year, during the summer vacations, IRC, conducts Summer Camp for boys and girls. The aim of this summer camp is to inculcate in our new generation authentic...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-exhibition')}>
                            <div className="home-value-icon"><FaImages size={50} color="#AA00FF" /></div>
                            <h3>IRC EXHIBITION & MUSEUM</h3>
                            <p>IRC organizes exhibitions on different themes such as Quran & Modern Science, Muslim Scientists, Islamic Civilizatin, Books, Social & Moral Evils, Coins, Currecy...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-minority')}>
                            <div className="home-value-icon"><FaSchool size={50} color="#FFAA55" /></div>
                            <h3>IRC MINORITY DEVELOPMENT CENTER (MDC)</h3>
                            <p>Empowering minorities through our Development Centre, we provide a spectrum of services Only for students, including career guidance, scholarships for government...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-alkitab')}>
                            <div className="home-value-icon"><img src={ALKITAB} alt="QR Code" className="qr-code" /></div>
                            <h3>AL KITAB EDUCATION & WELFARE SOCIETY</h3>
                            <p>Al Kitab Education & Welfare Society, founded by Adv. Faiz Syed, is a welfare organization dedicated to serving communities through initiatives in...</p>
                        </div>

                        <div className="home-value-card" onClick={() => handleCardClick('/irc-ilm')}>
                            <div className="home-value-icon"><img src={ILMICON} alt="QR Code" className="qr-code" /></div>
                            <h3>ILM FOUNDATION EDUCATION & WELFARE WAKF</h3>
                            <p>ILM Foundation Education & Welfare Wakf is an Religious Trust, the foundation is dedicated to uplifting society through initiatives in Religion, education, healthcare...</p>
                        </div>


                    </div>
                </section>

            </div>
        </>
    );
};

export default Activities;
